const ItCompanyFeature = () => {
  return (
    <>
      <div className="it-company-feature it-company-bg-two ptb-120 position-relative z-1">
        <div className="container">
          <div className="row justify-content-center">
            <div className="col-lg-6">
              <div className="text-center">
                <h2 className="it-company-title it-company-color fs-40 fw-600 flh-56 mb-40">
                  The Awards Won By Our Featured Project
                </h2>
              </div>
            </div>
          </div>
          <div className="row justify-content-center">
            <div className="col-xxl-10">
              <div className="it-company-feature-item d-flex align-items-center justify-content-between p-4 position-relative">
                <div className="it-company-feature-item-w_left">
                  <h6 className="it-company-color fs-24 fw-500 mb-0">Envato</h6>
                </div>
                <div className="it-company-feature-item-w text-center">
                  <h6 className="it-company-color fs-20 fw-400 mb-0">
                    Featured Products
                  </h6>
                </div>
                <div className=" d-flex align-items-center gap-3">
                  <h6 className="it-company-color fs-20 fw-400 mb-0">2022</h6>
                  <a href="">
                    <svg
                      width="26"
                      height="26"
                      viewBox="0 0 26 26"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path
                        d="M16.9054 10.5753L10.0753 8.74519L9.43477 11.1357L12.1668 11.8678L7.62019 14.4928L8.87019 16.6578L13.4168 14.0328L12.6848 16.7649L15.0753 17.4054L16.9054 10.5753ZM23.4006 6.82532C24.2652 8.32282 24.7934 9.89428 24.9851 11.5397C25.1775 13.1847 25.0679 14.7756 24.6561 16.3124C24.2443 17.8491 23.5439 19.2817 22.5547 20.6101C21.5659 21.9392 20.3228 23.0361 18.8253 23.9006C17.3278 24.7652 15.7564 25.2934 14.1109 25.4851C12.4659 25.6775 10.8751 25.5679 9.33828 25.1561C7.8015 24.7443 6.36856 24.0441 5.03945 23.0553C3.71107 22.0662 2.61458 20.8228 1.75 19.3253C0.885416 17.8278 0.3569 16.2566 0.164451 14.6116C-0.0272747 12.9662 0.0827498 11.3751 0.494529 9.83828C0.906308 8.3015 1.60678 6.86892 2.59594 5.54053C3.58469 4.21143 4.82781 3.11458 6.32532 2.25C7.82282 1.38542 9.39428 0.857261 11.0397 0.665535C12.6847 0.473086 14.2756 0.58275 15.8124 0.994529C17.3491 1.40631 18.7817 2.10678 20.1101 3.09594C21.4392 4.08469 22.5361 5.32781 23.4006 6.82532Z"
                        fill="black"
                      />
                    </svg>
                  </a>
                </div>
                <img
                  src="assets/img/it_company/feature.png"
                  alt=""
                  className="it-company-feature-img position-absolute"
                />
              </div>
              <div className="it-company-feature-item d-flex align-items-center justify-content-between p-4 position-relative border-top border-bottom">
                <div className="it-company-feature-item-w_left">
                  <h6 className="it-company-color fs-24 fw-500 mb-0">
                    Awwwards
                  </h6>
                </div>
                <div className="it-company-feature-item-w text-center">
                  <h6 className="it-company-color fs-20 fw-400 mb-0">
                    Site of the day
                  </h6>
                </div>
                <div className=" d-flex align-items-center gap-3">
                  <h6 className="it-company-color fs-20 fw-400 mb-0">2023</h6>
                  <a href="">
                    <svg
                      width="26"
                      height="26"
                      viewBox="0 0 26 26"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path
                        d="M16.9054 10.5753L10.0753 8.74519L9.43477 11.1357L12.1668 11.8678L7.62019 14.4928L8.87019 16.6578L13.4168 14.0328L12.6848 16.7649L15.0753 17.4054L16.9054 10.5753ZM23.4006 6.82532C24.2652 8.32282 24.7934 9.89428 24.9851 11.5397C25.1775 13.1847 25.0679 14.7756 24.6561 16.3124C24.2443 17.8491 23.5439 19.2817 22.5547 20.6101C21.5659 21.9392 20.3228 23.0361 18.8253 23.9006C17.3278 24.7652 15.7564 25.2934 14.1109 25.4851C12.4659 25.6775 10.8751 25.5679 9.33828 25.1561C7.8015 24.7443 6.36856 24.0441 5.03945 23.0553C3.71107 22.0662 2.61458 20.8228 1.75 19.3253C0.885416 17.8278 0.3569 16.2566 0.164451 14.6116C-0.0272747 12.9662 0.0827498 11.3751 0.494529 9.83828C0.906308 8.3015 1.60678 6.86892 2.59594 5.54053C3.58469 4.21143 4.82781 3.11458 6.32532 2.25C7.82282 1.38542 9.39428 0.857261 11.0397 0.665535C12.6847 0.473086 14.2756 0.58275 15.8124 0.994529C17.3491 1.40631 18.7817 2.10678 20.1101 3.09594C21.4392 4.08469 22.5361 5.32781 23.4006 6.82532Z"
                        fill="black"
                      />
                    </svg>
                  </a>
                </div>
                <img
                  src="assets/img/it_company/feature.png"
                  alt=""
                  className="it-company-feature-img position-absolute"
                />
              </div>
              <div className="it-company-feature-item d-flex align-items-center justify-content-between p-4 position-relative border-bottom">
                <div className="it-company-feature-item-w_left">
                  <h6 className="it-company-color fs-24 fw-500 mb-0">
                    Awwwards
                  </h6>
                </div>
                <div className="it-company-feature-item-w text-center">
                  <h6 className="it-company-color fs-20 fw-400 mb-0">
                    Site of the day
                  </h6>
                </div>
                <div className=" d-flex align-items-center gap-3">
                  <h6 className="it-company-color fs-20 fw-400 mb-0">2023</h6>
                  <a href="">
                    <svg
                      width="26"
                      height="26"
                      viewBox="0 0 26 26"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path
                        d="M16.9054 10.5753L10.0753 8.74519L9.43477 11.1357L12.1668 11.8678L7.62019 14.4928L8.87019 16.6578L13.4168 14.0328L12.6848 16.7649L15.0753 17.4054L16.9054 10.5753ZM23.4006 6.82532C24.2652 8.32282 24.7934 9.89428 24.9851 11.5397C25.1775 13.1847 25.0679 14.7756 24.6561 16.3124C24.2443 17.8491 23.5439 19.2817 22.5547 20.6101C21.5659 21.9392 20.3228 23.0361 18.8253 23.9006C17.3278 24.7652 15.7564 25.2934 14.1109 25.4851C12.4659 25.6775 10.8751 25.5679 9.33828 25.1561C7.8015 24.7443 6.36856 24.0441 5.03945 23.0553C3.71107 22.0662 2.61458 20.8228 1.75 19.3253C0.885416 17.8278 0.3569 16.2566 0.164451 14.6116C-0.0272747 12.9662 0.0827498 11.3751 0.494529 9.83828C0.906308 8.3015 1.60678 6.86892 2.59594 5.54053C3.58469 4.21143 4.82781 3.11458 6.32532 2.25C7.82282 1.38542 9.39428 0.857261 11.0397 0.665535C12.6847 0.473086 14.2756 0.58275 15.8124 0.994529C17.3491 1.40631 18.7817 2.10678 20.1101 3.09594C21.4392 4.08469 22.5361 5.32781 23.4006 6.82532Z"
                        fill="black"
                      />
                    </svg>
                  </a>
                </div>
                <img
                  src="assets/img/it_company/feature.png"
                  alt=""
                  className="it-company-feature-img position-absolute"
                />
              </div>
              <div className="it-company-feature-item d-flex align-items-center justify-content-between p-4 position-relative border-bottom">
                <div className="it-company-feature-item-w_left">
                  <h6 className="it-company-color fs-24 fw-500 mb-0">
                    Awwwards
                  </h6>
                </div>
                <div className="it-company-feature-item-w text-center">
                  <h6 className="it-company-color fs-20 fw-400 mb-0">
                    Site of the day
                  </h6>
                </div>
                <div className=" d-flex align-items-center gap-3">
                  <h6 className="it-company-color fs-20 fw-400 mb-0">2023</h6>
                  <a href="">
                    <svg
                      width="26"
                      height="26"
                      viewBox="0 0 26 26"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path
                        d="M16.9054 10.5753L10.0753 8.74519L9.43477 11.1357L12.1668 11.8678L7.62019 14.4928L8.87019 16.6578L13.4168 14.0328L12.6848 16.7649L15.0753 17.4054L16.9054 10.5753ZM23.4006 6.82532C24.2652 8.32282 24.7934 9.89428 24.9851 11.5397C25.1775 13.1847 25.0679 14.7756 24.6561 16.3124C24.2443 17.8491 23.5439 19.2817 22.5547 20.6101C21.5659 21.9392 20.3228 23.0361 18.8253 23.9006C17.3278 24.7652 15.7564 25.2934 14.1109 25.4851C12.4659 25.6775 10.8751 25.5679 9.33828 25.1561C7.8015 24.7443 6.36856 24.0441 5.03945 23.0553C3.71107 22.0662 2.61458 20.8228 1.75 19.3253C0.885416 17.8278 0.3569 16.2566 0.164451 14.6116C-0.0272747 12.9662 0.0827498 11.3751 0.494529 9.83828C0.906308 8.3015 1.60678 6.86892 2.59594 5.54053C3.58469 4.21143 4.82781 3.11458 6.32532 2.25C7.82282 1.38542 9.39428 0.857261 11.0397 0.665535C12.6847 0.473086 14.2756 0.58275 15.8124 0.994529C17.3491 1.40631 18.7817 2.10678 20.1101 3.09594C21.4392 4.08469 22.5361 5.32781 23.4006 6.82532Z"
                        fill="black"
                      />
                    </svg>
                  </a>
                </div>
                <img
                  src="assets/img/it_company/feature.png"
                  alt=""
                  className="it-company-feature-img position-absolute"
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default ItCompanyFeature;
